import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { IconButton } from '../design-system';

const DarkModeToggle = ({ isDarkMode, toggleDarkMode }) => {
  return (
    <IconButton
      onClick={toggleDarkMode}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      data-tour="dark-mode-toggle"
      icon={
        isDarkMode ? (
          <Sun size={16} style={{ color: 'var(--accent-ink)' }} />
        ) : (
          <Moon size={16} />
        )
      }
    />
  );
};

export default DarkModeToggle;
